export function arrayEqual(firstArray, secondArray) {
  if (!Array.isArray(firstArray) || !Array.isArray(secondArray)) {
    return false;
  }
  if (firstArray.length !== secondArray.length) {
    return false;
  }
  for (const [i, element] of firstArray.entries()) {
    if (element !== secondArray[i]) {
      return false;
    }
  }
  return true;
}